/* Brand pre-footer
   - Portals the next testimonials section into the mount point so the
     testimonials block renders above "Ons verhaal" instead of as a separate row.
   - Click-to-toggle play/pause on the brand video. */

(function () {
  function lazyLoadVideos() {
    var videos = document.querySelectorAll('.brand-pre-footer__video[data-src]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) {
        v.src = v.dataset.src;
        v.removeAttribute('data-src');
        v.load();
        var p = v.play(); if (p && typeof p.catch === 'function') p.catch(function () {});
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var v = entry.target;
        if (!v.dataset.src) return;
        v.src = v.dataset.src;
        v.removeAttribute('data-src');
        v.load();
        var p = v.play(); if (p && typeof p.catch === 'function') p.catch(function () {});
        io.unobserve(v);
      });
    }, { rootMargin: '400px 0px' });
    videos.forEach(function (v) { io.observe(v); });
  }

  function portalTestimonials() {
    var mount = document.querySelector('.brand-pre-footer [data-testimonials-mount]');
    if (!mount) return;
    var testimonials = document.querySelector('.section-testimonials:not(.section-testimonials--portaled)');
    if (!testimonials) return;
    if (mount.contains(testimonials)) return;
    mount.appendChild(testimonials);
    testimonials.classList.add('section-testimonials--portaled');
  }

  function wireVideoToggle() {
    document.querySelectorAll('.brand-pre-footer__media').forEach(function (media) {
      if (media.dataset.toggleBound === 'true') return;
      var video = media.querySelector('.brand-pre-footer__video');
      if (!video) return;
      media.dataset.toggleBound = 'true';
      media.addEventListener('click', function () {
        if (video.paused) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked */ });
        } else {
          video.pause();
        }
        media.classList.toggle('is-paused', video.paused);
      });
      // Keep the visual state in sync if the video pauses for any other reason
      // (e.g. tab loses focus, end of file with loop disabled, etc.).
      video.addEventListener('pause', function () { media.classList.add('is-paused'); });
      video.addEventListener('play', function () { media.classList.remove('is-paused'); });
    });
  }

  function init() {
    portalTestimonials();
    wireVideoToggle();
    lazyLoadVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
